/* eslint-disable camelcase */
/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import SwipeableViews from 'react-swipeable-views'
import MobileStepper from '@mui/material/MobileStepper'
import { useDispatch, useSelector } from 'react-redux'
import CustomButton from '../CustomButton'
import { setActiveStep, setProjectInputStep } from '../../slices/mainTool'
import config from '../../config/config'
import { setMaploaded, setShowStreetmixIntroModal } from '../../slices/appSlice'
import ProjectInputsTwo from './ProjectInputsTwo'
import ProjectInputsThree from './ProjectInputsThree'
import ProjectInputsOne from './ProjectInputsOne'
import { set } from 'lodash'

export default function SwipeableProjectInputs() {
  const [missingFields, setMissingFields] = useState([])
  const dispatch = useDispatch()
  const { activeStep, projectInputStep } = useSelector(
    (state) => state.mainTool
  )
  const { roadway_name, street_width, land_use_context } = useSelector(
    (state) => state.roadwayVariables
  )
  const {
    Pedestrian: PTier,
    Bicycle: BTier,
    Transit: TTier,
    Auto: ATier,
    Freight: FTier
  } = useSelector((state) => state.modalTiers)

  const handleNext = () => {
    if (projectInputStep === 2) {
      const showStreetmixIntroModal = localStorage.getItem(
        'showStreetmixIntroModal'
      )
        ? JSON.parse(localStorage.getItem('showStreetmixIntroModal'))
        : true
      showStreetmixIntroModal && dispatch(setShowStreetmixIntroModal(true))
      dispatch(setActiveStep(1))
      dispatch(setMaploaded(false))
    } else {
      dispatch(setProjectInputStep(projectInputStep + 1))
    }
  }

  const handleBack = () => {
    dispatch(setProjectInputStep(projectInputStep - 1))
  }

  useEffect(() => {
    const missingFieldsCopy = []
    if (
      (projectInputStep === 0 ||
        projectInputStep === 1 ||
        projectInputStep === 2) &&
      land_use_context === ''
    ) {
      missingFieldsCopy.push('Land Use Context')
    }
    if (
      (projectInputStep === 1 || projectInputStep === 2) &&
      street_width === ''
    ) {
      missingFieldsCopy.push('Street Width')
    }
    if (
      (projectInputStep === 1 || projectInputStep === 2) &&
      roadway_name === ''
    ) {
      missingFieldsCopy.push('Roadway Name')
    }
    if (
      projectInputStep === 2 &&
      PTier === 0 &&
      BTier === 0 &&
      TTier === 0 &&
      ATier === 0 &&
      FTier === 0
    ) {
      missingFieldsCopy.push('Modal Tier')
    }
    setMissingFields(missingFieldsCopy)
  }, [
    roadway_name,
    street_width,
    land_use_context,
    PTier,
    BTier,
    TTier,
    ATier,
    FTier,
    projectInputStep
  ])

  return (
    <Box
      sx={{
        height: '100%',
        display: 'grid',
        gridTemplateRows: '75% 25%',
        pl: '4em',
        pr: '4em'
      }}
    >
      {/* <Box
        sx={{
          display: 'grid'
        }}
      >
        {projectInputStep === 0 ? (
          <ProjectInputsOne />
        ) : projectInputStep === 1 ? (
          <ProjectInputsTwo />
        ) : (
          <ProjectInputsThree />
        )}
      </Box> */}
      <SwipeableViews index={projectInputStep} style={{ overflow: 'hidden' }}>
        <ProjectInputsOne />
        <ProjectInputsTwo />
        <ProjectInputsThree />
      </SwipeableViews>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignSelf: 'flex-start'
        }}
      >
        <CustomButton
          handleNext={handleBack}
          btnLabel="Back"
          visibility={projectInputStep !== 0 ? 'visible' : 'hidden'}
          marginTop={0}
          backgroundColor={config.themeConfig.semcogBlue1}
        />
        <MobileStepper
          sx={{
            justifySelf: 'center',
            '& .MuiMobileStepper-dot': {
              width: '15px',
              height: '15px'
            }
          }}
          variant="dots"
          steps={3}
          position="static"
          activeStep={projectInputStep}
        />
        <CustomButton
          handleNext={handleNext}
          btnLabel="Next"
          // visibility={projectInputStep !== 2 ? 'visible' : 'hidden'}
          marginTop={0}
          disabled={
            // if user is in manual street mode, check for missing variables
            (projectInputStep === 0 && land_use_context === '') ||
            (projectInputStep === 1 &&
              (roadway_name === '' ||
                street_width === '' ||
                land_use_context === '')) ||
            (projectInputStep === 2 &&
              (roadway_name === '' ||
                street_width === '' ||
                land_use_context === '' ||
                (PTier === 0 &&
                  BTier === 0 &&
                  TTier === 0 &&
                  ATier === 0 &&
                  FTier === 0)))
          }
          showDisabledTooltip={true}
          helpText={`Please fill out all these missing fields before continuing: ${missingFields.join(
            ', '
          )}`}
          backgroundColor={config.themeConfig.semcogBlue1}
        />
      </Box>
    </Box>
  )
}
